/* Liquid Glass interaction: cursor reflections, 3D tilt, scroll parallax */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Elements that lean (tilt) toward the cursor */
  var TILT = '.product-card, .product-gallery__main, .category-tile, .testimonial-card, .trust-badge, .hero__float, .story-float';
  /* Elements that track the pointer for the glow/sweep (superset) */
  var TRACK = TILT + ', .site-header__inner, .btn--secondary, .btn--outline, .cart-summary, .email-signup__wrapper';
  var MAX_TILT = 7;

  function onMove(e) {
    var el = e.currentTarget;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var px = (e.clientX - r.left) / r.width;
    var py = (e.clientY - r.top) / r.height;
    el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
    el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    if (!reduce && el.matches(TILT)) {
      el.style.setProperty('--rx', ((px - 0.5) * 2 * MAX_TILT).toFixed(2) + 'deg');
      el.style.setProperty('--ry', ((0.5 - py) * 2 * MAX_TILT).toFixed(2) + 'deg');
    }
  }
  function onLeave(e) {
    var el = e.currentTarget;
    el.style.setProperty('--rx', '0deg');
    el.style.setProperty('--ry', '0deg');
  }

  document.querySelectorAll(TRACK).forEach(function (el) {
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerleave', onLeave);
  });

  /* Scroll-reactive backdrop parallax */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      document.documentElement.style.setProperty('--sy', String(window.scrollY));
      ticking = false;
    });
  }, { passive: true });
})();
